<div class="flex flex-col items-center justify-center h-auto mt-16 text-center space-y-4">

    <img src="svg/hand.svg" class="h-20 w-20" alt="">
  <h1 class="my-4 text-dark-blue font-bold text-2xl">¡Felicitaciones!</h1>
  <p class="text-base text-black">Has concluido tu actualización de datos.</p>

  <button class="btn-primary" (click)="finish()">
    Finalizar proceso
  </button>
  
  <button class="btn-secundary" (click)="downloadPDF()">
    Descargar mi certificado
  </button>

</div>